<script>
	import ConsentManagerMorePreferences from '$components/ConsentManager/ConsentManagerMorePreferences.svelte';
</script>

<ConsentManagerMorePreferences />
